import { useState } from "react";
import "../../styles/common/feedbackModal.css";
import ErrorToast from "./ErrorToast";
import { sendFeedback } from "../../services/feedback.service.js";

const EXPERIENCES = ["Excellent", "Very Good", "Good", "Average", "Poor"];

const FeedbackModal = ({ open, setOpen }) => {
  const [experience, setExperience] = useState("Good");
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (!open) return null;

  const submitHandler = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      await sendFeedback({ experience, text });
      setOpen(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="feedback-overlay">
      <div className="feedback-modal">
        <ErrorToast error={error} background={false} />
        <h2 className="feedback-title">Share your feedback</h2>
        <form onSubmit={submitHandler}>
          <label className="feedback-label">Experience</label>
          <select
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            className="feedback-select"
          >
            {EXPERIENCES.map((exp) => (
              <option key={exp} value={exp}>
                {exp}
              </option>
            ))}
          </select>

          <label className="feedback-label">
            Your thoughts<p className="red-text">*</p>
          </label>
          <textarea
            placeholder="Tell us what you liked or what can be improved..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            className="feedback-textarea"
            required
          />

          <div className="feedback-actions">
            <button
              type="button"
              className="btn secondary"
              onClick={() => setOpen(false)}
              disabled={isLoading}
            >
              Cancel
            </button>

            <button type="submit" className="btn primary" disabled={isLoading}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
